/// <reference path="app.definition.ts" />

'use strict';

import angular from "angular";

export class Routes {

    static $inject = ["$stateProvider", "$urlRouterProvider"];

    constructor($stateProvider: ng.ui.IStateProvider,
                $urlRouterProvider: ng.ui.IUrlRouterProvider) {

        if (!!extModule && extModule == 'analytics') {
            $stateProvider
                .state('default', {
                    url: '',
                    views: {
                        "mainView": {
                            template: '<div ></div>'
                        }
                    }

                })
                .state('load-report', {
                    url: '/load-report',
                    views: {
                        "mainView": {
                            templateUrl: 'app/analytics/view-report/view-report.html',
                            controller: 'ViewReportController as vrVm'
                        }
                    }
                });
        } else if (!extModule) {
            $stateProvider
                .state('ecare-vault', {
                    url: '/ecare-vault',
                    redirectTo: 'login',
                    template: '<div ui-view="appView"></div>'
                })
                .state('open', {
                    parent: 'parent',
                    url: '/open',
                    views: {
                        "mainView": {
                            template: '<div></div>',
                            controller: 'OpenViewController as openViewVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/openview/openview.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.openView' });
                            });
                        }]
                    }
                })
                .state('terms_out', {
                    parent: 'ecare-vault',
                    url: '/terms',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/template/terms.html'
                        }
                    }
                })
                .state('privacy_out', {
                    parent: 'ecare-vault',
                    url: '/ecareprivacy',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/template/privacy.html'
                        }
                    }
                })
                .state('login-wrapper', {
                    parent: 'ecare-vault',
                    url: '',
                    views: {
                        "appView": {
                            templateUrl: 'app/authentication/components/auth-page/auth-login.html',
                            controller: 'AuthenticationController as loginVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./authentication/authentication.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.authentication' });
                            });
                        }],
                    }
                })
                .state('cr-profile', {
                    parent: 'parent',
                    url: '/cr-profile/{id}',
                    views: {
                        "mainView": {
                            templateUrl: 'app/common/cr-profile-page/cr-profile-page.html',
                            controller: 'CrProfilePageController as crProfileVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/cr-profile-page/cr-profile-page.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.cr-profile-page' });
                            });
                        }]
                    }
                })
                .state('organize', {
                    parent: 'parent',
                    url: '/organize/{folderId}/{ref}',
                    views: {
                        "mainView": {
                            templateUrl: 'app/common/uploadDocuments/components/organizePage/organize-page.html',
                            controller: 'OrganizePageController as organizeVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/uploadDocuments/uploadDocuments.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.uploadDocuments' });
                            });
                        }]
                    }
                })
                .state('connect', {
                    parent: 'parent',
                    url: '/connect/{folderId}/{ref}',
                    views: {
                        "mainView": {
                            templateUrl: 'app/common/createDiscussion/components/connectPage/connect-page.html',
                            controller: 'ConnectPageController as connectVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/createDiscussion/createDiscussion.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.createDiscussion' });
                            });
                        }]
                    }
                })
                .state('password-reset', {
                    parent: 'ecare-vault',
                    url: '/passwordreset',
                    views: {
                        "appView": {
                            templateUrl: 'app/authentication/components/passwordReset/passwordreset.html',
                            controller: 'PasswordResetController as pwResetVm'
                        }
                    }
                })
                .state('corrupt-password-reset', {
                    parent: 'ecare-vault',
                    url: '/vkreset',
                    views: {
                        "appView": {
                            templateUrl: 'app/authentication/components/login/corruptvkreset.html',
                            controller: 'CorruptVkResetController as crptPwResetVm'
                        }
                    }
                })
                .state('login', {
                    parent: 'login-wrapper',
                    url: '/login',
                    views: {
                        "signup-view": {
                            templateUrl: 'app/authentication/components/signup/template/signupcontainer.html',
                            controller: 'SignupController as signUpVm'
                        }
                    }
                })
                .state('parent', {
                    parent: 'ecare-vault',
                    url: '/parent',
                    redirectTo: 'parent-careteam',
                    views: {
                        "appView": {
                            templateUrl: 'app/parent.app.html',
                            controller: 'AppController as appVm',
                        }
                    }
                })
                .state('parent-privacy', {
                    parent: 'ecare-vault',
                    url: '/privacy',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/privacy/privacy.html',
                            controller: 'PrivacyController as privacyVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/privacy/privacy.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.privacy' });
                            });
                        }]
                    }
                })
                .state('provider-privacy', {
                    parent: 'ecare-vault',
                    url: '/privacy',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/privacy/privacy.html',
                            controller: 'PrivacyController as privacyVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/privacy/privacy.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.privacy' });
                            });
                        }]
                    }
                })
                .state('shared_out', {
                    parent: 'ecare-vault',
                    url: '/public/{code}',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/viewShared/viewShared.html',
                            controller: 'ViewSharedController as viewSharedVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/viewShared/viewShared.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.viewShared' });
                            });
                        }]
                    }
                })
                .state('shared_out_link', {
                    parent: 'ecare-vault',
                    url: '/public/vlink/{code}',
                    views: {
                        "appView": {
                            templateUrl: 'app/common/viewShared/viewShared.html',
                            controller: 'ViewSharedController as viewSharedVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./common/viewShared/viewShared.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.common.viewShared' });
                            });
                        }]
                    }
                })
                .state('parent-profile-prime', {
                    parent: 'parent',
                    url: '',
                    views: {
                        "mainView": {
                            template: '<div ui-view="profile-view"></div>',
                            controller: 'MyProfileController as myProfileVm'
                        }
                    },
                    resolve: {
                        loadModule: ['$ocLazyLoad', function($ocLazyLoad) {
                            return import('./myProfile/myProfile.module').then(m => {
                                return $ocLazyLoad.load({ name: 'eCareVault.myProfile' });
                            });
                        }]
                    }
                })
                .state('parent-profile', {
                    parent: 'parent-profile-prime',
                    url: '/profile/{page}',
                    views: {
                        "profile-view": {
                            templateUrl: 'app/myProfile/components/myProfile.html'
                        }
                    }
                })
                .state('prime-signup-provider', {
                    parent: 'ecare-vault',
                    url: '/provider/signup',
                    views: {
                        "appView": {
                            template: '<div ui-view="provider-signup"></div>',
                            controller: 'SignupController as signUpVm'
                        }
                    }
                })
                .state('signup-provider', {
                    parent: 'prime-signup-provider',
                    url: '/details/{for}',
                    views: {
                        "provider-signup": {
                            templateUrl: 'app/authentication/components/signup/template/signup.provider.html'
                        }
                    }
                })
                .state('parent-carefeed', {
                    url: '/carefeed',
                    params: {
                            bell: { value: null, squash: true }
                    },
                    resolve: {
                        // This function will dynamically load the carefeed module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadMultipleRemoteModules([
                                { moduleName: 'documentSignature', exposedModule: 'documentSignature/documentSignatureModule', ecvModule: 'eCareVault.documentSignature' },
                                { moduleName: 'carefeed', exposedModule: 'carefeed/carefeedModule', ecvModule: 'eCareVault.carefeed' }]);
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', function($state) {
                        if($state.params && $state.params.bell) {
                            $state.go('carefeed-bell', { bell: true });
                        } else {
                            $state.go('manage-carefeed');
                        }
                    }]
                })
                .state({
                    name: 'parent.forms',
                    abstract: true,
                    url: '/form',
                    parent: 'parent'
                })
                .state('forms-load', {
                    url: '/forms/load',
                    params: {
                        redirectState: null,
                        action: { value: null, squash: true },
                        formId: {squash: true, value: null},
                        asgnId: {squash: true, value: null},
                        ref: {squash: true, value: null},
                        subjectId: {squash: true, value: null}
                    },
                    resolve: {
                        // This function will dynamically load the forms module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('forms', 'forms/formsModule', 'eCareVault.forms');
                        }]

                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function($state, $location, $urlRouter) {
                        if($state.params) {
                            if($state.params.redirectState) {
                                $location.url($state.params.redirectState);
                                $urlRouter.sync();
                                return;
                            }
                            if($state.params.action === 'fill') {
                                $state.go('parent.forms.fill', { asgnId: $state.params.asgnId, ref: $state.params.ref, subjectId: $state.params.subjectId });
                            } else if($state.params.action === 'view') {
                                $state.go('parent.forms.view', { formId: $state.params.formId, asgnId: $state.params.asgnId, ref: $state.params.ref, subjectId: $state.params.subjectId });
                            } else {
                                $state.go('parent.forms.manage-forms');
                            }
                        } else {
                            $state.go('parent.forms.manage-forms');
                        }
                    }]
                })
                .state({
                    name: 'parent.user',
                    abstract: true,
                    url: '/',
                    parent: 'parent'
                })
                .state('user-management-load', {
                    url: '/user-management/load',
                    resolve: {
                        // This function will dynamically load the user management module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('userManagement', 'userManagement/userManagementModule', 'eCareVault.userManagement');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', function ($state) {
                        $state.go('parent.user.management');
                    }]
                })
                .state({
                    name: 'parent.systemMessages',
                    abstract: true,
                    url: '/',
                    parent: 'parent'
                })
                .state('org-system-message-load', {
                    url: '/system-message/load',
                    resolve: {
                        // This function will dynamically load the org admin module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('userManagement', 'userManagement/userManagementModule', 'eCareVault.userManagement');                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', function ($state) {
                        $state.go('parent.systemMessages.load');
                    }]
                })
                .state({
                    name: 'parent.services',
                    abstract: true,
                    url: '/services',
                    parent: 'parent'
                })
                .state('services-load', {
                    url: '/services/load',
                    params: {
                        redirectState: null,
                        page: { value: null, squash: true },
                        serviceId: { value: null, squash: true },
                        serviceNoteId: { value: null, squash: true}
                    },
                    resolve: {
                        // This function will dynamically load the forms module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('services', 'services/ecvServicesModule', 'eCareVault.ecvServices');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function($state, $location, $urlRouter) {
                        if($state.params) {
                            if($state.params.redirectState) {
                                let url = $state.params.redirectState.replace('/parent/service/', '/parent/services/'); //to handle routes for email notifications
                                $location.url(url);
                                $urlRouter.sync();
                                return;
                            }
                            if($state.params.page === 'availableServices' || $state.params.page === 'currentServices' || $state.params.page === 'previousServices') {
                                $state.go('parent.services.manage', {page: $state.params.page});
                            }else if(!!$state.params.serviceId || !!$state.params.serviceNoteId){
                                $state.go('parent.services.view', {serviceId: $state.params.serviceId , serviceNoteId: $state.params.serviceNoteId});
                            }
                            else {
                                $state.go('parent.services.manage');
                            }
                        } else {
                            $state.go('parent.services.manage');
                        }
                    }]

                })
                .state({
                    name: 'parent.analytics',
                    abstract: true,
                    url: '/analytics',
                    parent: 'parent'
                })
                .state('analytics-load', {
                    url: '/analytics/load',
                    params: {
                        redirectState: null,
                        action: { value: null, squash: true },
                        reportData: { value: null, squash: true }
                    },
                    resolve: {
                        // This function will dynamically load the analytics module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('analytics', 'analytics/analyticsModule', 'eCareVault.analytics');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function($state, $location, $urlRouter) {
                        if($state.params) {
                            if($state.params.redirectState) {
                                let url = $state.params.redirectState.replace('/parent/reports/', '/parent/analytics/reports/'); //to handle routes for email notifications
                                $location.url(url);
                                $urlRouter.sync();
                                return;
                            }
                            if (!!$state.params.reportData) {
                                $state.go('parent.analytics.view-report', { reportData: $state.params.reportData });
                            } else {
                                $state.go('parent.analytics.list-report');
                            }
                        } else {
                            $state.go('parent.analytics.list-report');
                        }
                    }]
                })
                .state('documents-load', {
                    url: '/documents/load',
                    params: {
                        redirectState: null,
                        action: { value: null, squash: true },
                        stateParams: { value: null, squash: true }
                    },
                    resolve: {
                        // This function will dynamically load the documents module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadMultipleRemoteModules([
                                { moduleName: 'documentSignature', exposedModule: 'documentSignature/documentSignatureModule', ecvModule: 'eCareVault.documentSignature' },
                                { moduleName: 'documents', exposedModule: 'documents/documentsModule', ecvModule: 'eCareVault.documents' }
                            ]);
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function ($state, $location, $urlRouter) {
                        if (!!$state.params && $state.params.redirectState) {
                            $location.url($state.params.redirectState);
                            $urlRouter.sync();
                            return;
                        }
                        if (!!$state.params.action) {
                            $state.go($state.params.action, $state.params.stateParams);
                        }
                    }]
                })
                .state('discussions-load', {
                    url: '/discussions/load',
                    params: {
                        redirectState: null,
                        action: { value: null, squash: true },
                        stateParams: { value: null, squash: true }
                    },
                    resolve: {
                        // This function will dynamically load the discussions module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('discussions', 'discussions/discussionsModule', 'eCareVault.discussions');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function ($state, $location, $urlRouter) {
                        if (!!$state.params && $state.params.redirectState) {
                            $location.url($state.params.redirectState);
                            $urlRouter.sync();
                            return;
                        }
                        if (!!$state.params.action) {
                            $state.go($state.params.action, $state.params.stateParams);
                        }
                    }]
                })
                .state('parent-dashboard', {
                    url: '/teams/load',
                    params: {
                        redirectState: null,
                        action: { value: null, squash: true },
                        previousState: { value: null, squash: true },
                        previousStateParams: { value: null, squash: true },
                        ref: { value: null, squash: true },
                        team: { value: null, squash: true }
                    },
                    resolve: {
                        // This function will dynamically load the teams module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('teams', 'teams/teamsModule', 'eCareVault.careTeam');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function ($state, $location, $urlRouter) {
                        if (!!$state.params) {
                            if($state.params.redirectState) {
                                $location.url($state.params.redirectState);
                                $urlRouter.sync();
                                return;
                            } else if ($state.params.action) {
                                $state.go($state.params.action, {previousState: $state.params.previousState, previousStateParams: $state.params.previousStateParams});
                                return;
                            }
                        }
                        $state.go('manage-teams', { ref: $state.params.ref, team: $state.params.team });

                    }]
            })
                .state('dashboard-load', {
                    url: '/dashboard/load',
                    params: {
                        redirectState: null
                    },
                    resolve: {
                        // This function will dynamically load the dashboard module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('dashboard', 'dashboard/dashboardModule', 'eCareVault.globalDashboard');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', '$location', '$urlRouter', function ($state, $location, $urlRouter) {
                        if (!!$state.params && $state.params.redirectState) {
                            $location.url($state.params.redirectState);
                            $urlRouter.sync();
                            return;
                        }
                        $state.go('parent-globalDashboard', {});

                    }]
                })
                .state('cover-sheet-load', {
                    url: '/cover-sheet/load',
                    params: {},
                    resolve: {
                        // This function will dynamically load the coversheet module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('coversheet', 'coversheet/coverSheetModule', 'eCareVault.coverSheetUploads');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', function ($state) {
                        $state.go('fax_uploads_out', {});
                    }]
                })
                .state('search-load', {
                    url: '/search/load',
                    params: {},
                    resolve: {
                        // This function will dynamically load the search module and its states.
                        loadAndRegister: ['ModuleFederationService', function(ModuleFederationService) {
                            return ModuleFederationService.loadRemoteModule('search', 'search/searchModule', 'eCareVault.search');
                        }]
                    },
                    // After the resolve is complete, this controller runs.
                    controller: ['$state', function ($state) {
                        $state.go('search', {});
                    }]
                });
            $urlRouterProvider.otherwise(($injector, $location, $rootScope) => {
                const $state = $injector.get('$state');
                const path = $location.path();

                // Check if the path looks like it belongs to the lazy-loaded module
                //This is needed when user is on the forms module and does a hard refresh
                if (path.startsWith('/ecare-vault/parent/form')) {
                    // If so, go to forms gateway state. It will load the module and retry the URL.
                    $state.go('forms-load', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/carefeed')) {
                    // If so, go to carefeed gateway state. It will load the module and retry the URL.
                    $state.go('parent-carefeed', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/usermanagement')) {
                    $state.go('user-management-load', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/systemmessage')) {
                    // If so, go to org admin gateway state. It will load the module and retry the URL.
                    $state.go('org-system-message-load', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/analytics') || path.startsWith('/ecare-vault/parent/reports')) {
                    // If so, go to analytics gateway state. It will load the module and retry the URL.
                    $state.go('analytics-load', { redirectState: path });
                } else if(path.startsWith('/ecare-vault/parent/discussion-board')){
                    $state.go('discussions-load', { redirectState: path });
                }else if (path.startsWith('/ecare-vault/parent/service')) {
                    $state.go('services-load', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/team-vault') || path.startsWith('/ecare-vault/parent/rl-board')) {
                    $state.go('documents-load', { redirectState: path });
                } else if(path.startsWith('/ecare-vault/parent/globalDashboard')){
                    $state.go('dashboard-load', { redirectState: path });
                } else if (path.startsWith('/ecare-vault/parent/fax_uploads_out')) {
                    $state.go('cover-sheet-load');
                } else if (path.startsWith('/ecare-vault/parent/search/results')) {
                    $state.go('search-load');
                } else if(path.startsWith('/ecare-vault/parent/careteams') || path.startsWith('/ecare-vault/parent/subject')) {
                    $state.go('parent-dashboard', { redirectState: path });
                }
                else {
                    // Otherwise, it's a truly unknown URL, so go to the login page.
                    // Before navigating to login, ensure any existing auth sessions are cleared.
                    if(window['ecvAuth'] && window['ecvAuth'].getAllAccounts().length > 0){
                        const logoutRequest = {
                            account: window['ecvAuth'].getAllAccounts()[0]
                        };
                        window['ecvAuth'].logout(logoutRequest);
                    }
                    $state.go('login');
                }
                // We must return a path for the router to follow initially.
                // Since we are handling the transition with $state.go, we can return the current path.
                return $location.path();
            });
        }
    }
}

angular.module('eCareVault')
    .config(Routes);
